"use client";

import { forwardRef, PropsWithChildren } from "react";
import { Wrapper } from "./content-transition-page.styles";

export interface ContentTransitionPageProps {
    /**
     * Class name of the dot.
     */
    className?: string;
}

export const ContentTransitionPage = forwardRef<HTMLDivElement, PropsWithChildren<ContentTransitionPageProps>>(({ className, children }, ref) => {
    return (
        <Wrapper className={className} ref={ref}>
            {children}
        </Wrapper>
    );
});

ContentTransitionPage.displayName = "ContentTransitionPage";
